'use client';

import { ToolsSidebarFeature } from '../common/features/tools-sidebar-feature';
import { createUseFlag } from './create-use-flag';

export const useToolsSidebarFeature = createUseFlag(ToolsSidebarFeature);
